const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

/**
 * Validates a decorator object. Returns null if valid, or an error message string if invalid.
 */
export const validateDecorator = (decorator) => {
  if (decorator.action === undefined || decorator.action === null) {
    return "Invalid decorator property: 'action' is required";
  }
  if (decorator.action === '') {
    return "Invalid decorator property: 'action' must not be empty";
  }
  // Mirror JoyDocSchema.json anyOf constraint (lines 2772-2775):
  // at least one of icon or label must be present for the decorator to be visible
  const hasIcon = typeof decorator.icon === 'string' && decorator.icon.trim() !== '';
  const hasLabel = typeof decorator.label === 'string' && decorator.label.trim() !== '';
  if (!hasIcon && !hasLabel) {
    return "Invalid decorator: at least one of 'icon' or 'label' is required";
  }
  if (decorator.color !== undefined && decorator.color !== null && !HEX_COLOR_REGEX.test(decorator.color)) {
    return `Invalid decorator property: 'color' must be a hex string (e.g. #3B82F6), got '${decorator.color}'`;
  }
  return null;
};

export const mergeRowDecorators = (rowCommon, rowSpecific) => {
  if (rowSpecific == null) return rowCommon || [];
  return rowSpecific;
};

export const hasAnyRowDecorators = (rowCommon, rows) => {
  if (rowCommon && rowCommon.length > 0) return true;
  if (rows) {
    for (const row of rows) {
      if (row.deleted) continue;
      if (row.decorators?.all?.length > 0) return true;
    }
  }
  return false;
};
